import { shoppingGoodsItemStyle } from '_core/components/ShoppingGoodsItem/shoppingGoodsItemStyle'

export const articleStyle = theme => {
  const style = shoppingGoodsItemStyle(theme)

  return {
    cardMedia: style.cardMedia,
    cardContent: style.cardContent,

    date: {
      textAlign: 'right',
    },

    title: {
      margin: theme.spacing(0, 0, 2),
    },

    description: {
      margin: theme.spacing(2, 0),
    },

    content: {
      marginTop: theme.spacing(2),
      color: theme.variables.colors.contentText,

      // Prevent CKEditor/HTML content from breaking layout (e.g. wide images).
      '& .ck-content': {
        overflowWrap: 'anywhere',
      },
      '& .ck-content img': {
        display: 'block',
        maxWidth: '100%',
        height: 'auto',
      },
      '& .ck-content figure': {
        maxWidth: '100%',
        margin: theme.spacing(2, 0),
      },
      '& .ck-content figure.image img': {
        marginLeft: 'auto',
        marginRight: 'auto',
      },
      '& .ck-content iframe, & .ck-content video': {
        maxWidth: '100%',
      },
    },
    
    linking: {
      justifyContent: 'space-between',
      flexDirection: 'row-reverse',
    },
  }
}
